const InvoiceNum = (num) => {
    if (num == 1) {
        return "Initial";
    }
    else if (num >= 20 && num % 10 == 1) {
        return num + "st";
    }
    else if (num == 2 || (num >= 20 && num % 10 == 2)) {
        return num + "nd";
    }
    else if (num == 3 || (num >= 20 && num % 10 == 3)) {
        return num + "rd";
    }
    else {
        return num + "th";
    }
};
export default InvoiceNum;
